<div style="background: var(--lightgrey200); padding: 20px">
  <div
    style="
      width: 100%;
      min-height: calc(100vh - 300px);
      max-height: calc(100vh - 300px);
      overflow: auto;
      position: relative;
    ">
    <mat-tab-group
      vertical
      dynamicHeight
      class="cms-system"
      [selectedIndex]="tabSelectedIndex"
      (selectedTabChange)="changeOfLangTab($event.index)">
      @for (lang of settingsData.languages; track lang) {
        <mat-tab>
          <ng-template mat-tab-label>
            <p style="font-weight: bold">{{ 'general.' + lang | translate }}</p>
          </ng-template>
          <ng-template matTabContent>
            <!-- <gmm-edit-structure class="tab-content-mod" [structure]="structure" [selectableLanguages]="this.settingsData.languages" [language]="lang"></gmm-edit-structure> -->
            <div
              style="display: flex; width: 100%; min-height: 300px; min-width: 300px; min-height: calc(100vh - 310px)">
              <app-preview
                style="
                  flex: 3;
                  max-width: 50%;
                  min-height: 100%;
                  background: white;
                  margin-left: 10px;
                  border-radius: 5px;
                "
                [heightModified]="true"
                [item]="item[lang]"></app-preview>
              <div
                style="
                  flex: 2;
                  margin-left: 20px;
                  max-width: 70%;
                  min-width: 400px;
                  max-height: calc(100vh - 300px);
                  overflow: auto;
                ">
                <mat-accordion
                  class="cms-drag-list"
                  cdkDropList
                  (cdkDropListDropped)="drop($event, item[lang].content)">
                  @if (item[lang]?.content?.length === 0) {
                    <p style="text-align: center">No content to show yet. Add some with the button below.</p>
                  }
                  @for (subItem of item[lang]?.content; track subItem; let i = $index) {
                    <mat-expansion-panel
                      class="cms-drag-box mep-second"
                      cdkDrag>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <h4 style="text-transform: capitalize">
                            {{ subItem.type }}
                            <span class="cut-text">{{ getInfoData(subItem) }}</span>
                          </h4>
                          <span
                            class="material-icons"
                            cdkDragHandle
                            style="position: absolute; top: 15px; right: 40px; cursor: move">
                            drag_indicator
                          </span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent>
                        <div>
                          @if (subItem.type === 'text-block') {
                            <coin-gmm-text-block
                              [contentEdit]="true"
                              [item]="subItem"></coin-gmm-text-block>
                          }
                          @if (subItem.type === 'image-slider') {
                            <coin-gmm-image-slider
                              [contentEdit]="true"
                              [autoSlide]="false"
                              [item]="subItem"></coin-gmm-image-slider>
                          }
                          @if (subItem.type === $any('quote')) {
                            <coin-gmm-quote
                              [contentEdit]="true"
                              [item]="subItem"></coin-gmm-quote>
                          }
                          @if (subItem.type === 'spacer') {
                            <coin-gmm-spacer
                              [contentEdit]="true"
                              [item]="subItem"></coin-gmm-spacer>
                          }
                          @if (subItem.type === 'picture-container') {
                            <coin-gmm-picture-container
                              [heightModified]="true"
                              [contentEdit]="true"
                              [item]="subItem"></coin-gmm-picture-container>
                          }
                          @if (subItem.type === 'compilation') {
                            <coin-gmm-compilation
                              [contentEdit]="true"
                              [item]="subItem"
                              [startanimation]="true"></coin-gmm-compilation>
                          }
                          @if (subItem.type === 'numbers') {
                            <coin-gmm-numbers
                              [contentEdit]="true"
                              [noCounting]="true"
                              [item]="subItem"
                              [startanimation]="true"></coin-gmm-numbers>
                          }
                          @if (subItem.type === 'text-image-link') {
                            <coin-gmm-text-image-link
                              [contentEdit]="true"
                              [item]="subItem"></coin-gmm-text-image-link>
                          }
                          <!-- <gmm-link-list [contentEdit]="true" *ngIf="subItem.type === 'link-list'" [item]="subItem"  [translationFile]="languageData"></gmm-link-list> -->
                          @if (subItem.type === 'editor') {
                            <coin-html-editor
                              [contentEdit]="true"
                              [item]="subItem"></coin-html-editor>
                          }
                          @if (subItem.type === 'single-or-multi-image') {
                            <coin-email-single-double-image
                              [contentEdit]="true"
                              [item]="subItem"></coin-email-single-double-image>
                          }
                          @if (subItem.type === 'headline-with-subheadline') {
                            <coin-news-headline
                              [contentEdit]="true"
                              [item]="subItem"></coin-news-headline>
                          }
                          @if (subItem.type === 'download-file') {
                            <coin-download-file
                              [contentEdit]="true"
                              [item]="subItem"></coin-download-file>
                          }
                          @if (subItem.type === 'button') {
                            <coin-cms-button
                              [contentEdit]="true"
                              [item]="subItem"></coin-cms-button>
                          }
                          <div style="display: flex; justify-content: flex-end; margin-top: 20px">
                            <coin-v2-button
                              [type]="'secondary'"
                              [icon]="'close'"
                              [iconPos]="'right'"
                              [text]="'cms.news.remove-content' | translate"
                              (click)="removeContent(item[lang].content, i)"></coin-v2-button>
                          </div>
                        </div>
                      </ng-template>
                    </mat-expansion-panel>
                  }
                </mat-accordion>
                <div style="display: flex; justify-content: flex-end; margin-top: 20px">
                  @if (lang !== 'en') {
                    <coin-v2-button
                      style="margin-right: 8px"
                      [type]="'secondary'"
                      [icon]="'add'"
                      [iconPos]="'right'"
                      [text]="'cms.news.copy-from-english' | translate"
                      (click)="copyFromEnglish(item, lang)"></coin-v2-button>
                  }
                  <coin-v2-button
                    [type]="'primary'"
                    [icon]="'add'"
                    [iconPos]="'right'"
                    [text]="'cms.news.add-content' | translate"
                    (click)="addContent($safeNavigationMigration(item[lang]?.content))"></coin-v2-button>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</div>
